<template>
  <div>
    <button
      v-if="!isOpen"
      class="fixed top-4 left-4 z-50 bg-blue_primary text-white p-2 rounded-md shadow-md"
      aria-label="Open menu"
      @click="isOpen = true"
    >
      ☰
    </button>

    <aside
      :class="[
        'fixed top-0 left-0 h-full w-64 bg-blue_primary text-white flex flex-col transition-transform duration-300 z-40',
        { '-translate-x-full': !isOpen },
      ]"
    >
      <div class="h-16 border-b border-white/50 flex items-center justify-center">
        <img
          class="h-10 cursor-pointer"
          src="/kamvu/logox4.png"
          alt="Kamvu"
          @click="goHome"
        />
      </div>
      <div class="flex-1 overflow-y-auto p-4">
        <NavMenuList @navigate="isOpen = false" />
      </div>
    </aside>

    <div
      v-if="isOpen"
      class="fixed inset-0 bg-black/50 z-30"
      @click="isOpen = false"
    ></div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import NavMenuList from "./NavMenuList.vue";

// Menú lateral deslizable para móvil.
export default {
  components: { NavMenuList },
  setup() {
    const router = useRouter();
    const isOpen = ref(false);

    const goHome = () => {
      router.push({ name: "dashboard" });
      isOpen.value = false;
    };

    return { isOpen, goHome };
  },
};
</script>
